import { render, staticRenderFns } from "./LinkCalendarSetting.vue?vue&type=template&id=5a08410e&scoped=true&"
import script from "./LinkCalendarSetting.vue?vue&type=script&lang=js&"
export * from "./LinkCalendarSetting.vue?vue&type=script&lang=js&"
import style0 from "./LinkCalendarSetting.vue?vue&type=style&index=0&id=5a08410e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08410e",
  null
  
)

export default component.exports